<template>
  <LayoutJps v-if="isJps">
    <div class="jps-error-page">
      <h1 class="title">{{ errorStore.getErrorStatusCode() }}</h1>
      <p>{{ errorStore.getErrorMessage() }}</p>
    </div>
  </LayoutJps>
  <LayoutHina v-else-if="isHina">
    <div class="jps-error-page">
      <h1 class="title">{{ errorStore.getErrorStatusCode() }}</h1>
      <p>{{ errorStore.getErrorMessage() }}</p>
    </div>
  </LayoutHina>
</template>

<script lang="ts" setup>
const { siteName } = useSite()
const { isEn } = useI18n()
const { isJps, isHina, serviceType } = useServiceType()

const prefix = '/assets/' + serviceType + '/'

useHead({
  htmlAttrs: {
    lang: () => (isEn.value ? 'en' : 'ja'),
  },
  link: [
    {
      rel: 'icon',
      href: prefix + 'favicon/favicon.ico',
    },
    {
      rel: 'icon',
      type: 'image/svg+xml',
      href: prefix + 'favicon/favicon.svg',
    },
    {
      rel: 'apple-touch-icon',
      sizes: '180x180',
      href: prefix + 'favicon/apple-touch-icon.png',
    },
    {
      rel: 'mask-icon',
      href: prefix + 'favicon/mask-icon.svg',
      color: '#FFFFFF',
    },
  ],
  meta: [{ property: 'og:site_name', content: siteName() }],
})

const { getPageAndCache } = usePage()
const { meta } = await getPageAndCache()
useHead(meta)

const errorStore = useErrorStore()
if (import.meta.client) {
  console.info(meta)
  const errorPath = errorStore.getErrorPath()
  if (errorPath) {
    history.pushState(null, meta.title, errorPath)
  }
}
console.info()
</script>

<style lang="scss" scoped>
.jps-error-page {
  padding: 2rem;
  background: white;
}
</style>
